import { Text, ScrollView, View } from "react-native";
import { useState } from "react";
import axios, { AxiosError } from "axios";
import {
  TestButton as PrinterButton,
  PrinterInput,
  ResponseDisplay,
} from "./components/TestPrinter";
import { styles } from "./components/TestPrinter/styles";
import { getPrinterHost, getPrinterUrl } from "./selectors/printer";
import { Dispatch } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { setPrinterHost, setPrinterUrl } from "./actions/mode";
import { SetPrinterHostAction, SetPrinterUrlAction } from "./types/printer";

export default function Home() {
  const [statusResponse, setStatusResponse] = useState("");
  const [printResponse, setPrintResponse] = useState("");
  const printerHost = useSelector(getPrinterHost);
  const printerUrl = useSelector(getPrinterUrl);
  const dispatch =
    useDispatch<Dispatch<SetPrinterHostAction | SetPrinterUrlAction>>();

  const getStatus = async () => {
    try {
      const response = await axios.get(
        `${printerHost}/Status?printerUrl=${printerUrl}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setStatusResponse(JSON.stringify(response.data, null, 2));
    } catch (error) {
      const axiosError = error as AxiosError;
      const errorString = `Error Code: ${axiosError.code}\nMessage: ${axiosError.message}\nStatus: ${axiosError.response?.status}\nResponse Data: ${JSON.stringify(axiosError.response?.data)}\nRequest URL: ${axiosError.config?.url}\nRequest Method: ${axiosError.config?.method?.toUpperCase()}\nRequest Headers: ${JSON.stringify(axiosError.config?.headers)}`;
      setStatusResponse("Error getting status:\n" + errorString);
    }
  };

  const printData = async () => {
    try {
      const response = await axios.post(
        `${printerHost}/Ticket?printerUrl=${printerUrl}`,
        {
          orderId: "123",
          orderPin: "456",
          collectionUrl: "https://example.com/order/123",
          lane: "1",
          price: "100",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setPrintResponse(JSON.stringify(response.data, null, 2));
    } catch (error) {
      const axiosError = error as AxiosError;
      const errorString = `Error Code: ${axiosError.code}\nMessage: ${axiosError.message}\nStatus: ${axiosError.response?.status}\nResponse Data: ${JSON.stringify(axiosError.response?.data)}\nRequest URL: ${axiosError.config?.url}\nRequest Method: ${axiosError.config?.method?.toUpperCase()}\nRequest Headers: ${JSON.stringify(axiosError.config?.headers)}`;
      setPrintResponse("Error getting status: " + errorString);
    }
  };

  const clearResponses = () => {
    setStatusResponse("");
    setPrintResponse("");
  };

  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>Test Printer Manager</Text>
      <View style={styles.contentContainer}>
        <PrinterInput
          label="Printer Manager Host"
          value={printerHost || "http://localhost:5000"}
          onChangeText={(text) => {
            dispatch(setPrinterHost(text));
          }}
          placeholder="Enter printer host (e.g. http://localhost:5000)"
        />
        <PrinterInput
          label="Printer Name"
          value={printerUrl}
          onChangeText={(text) => {
            dispatch(setPrinterUrl(text));
          }}
          placeholder="Enter printer Name (e.g. Honeywell MPD31DD)"
        />
        <PrinterButton
          onPress={getStatus}
          label="Get Status"
          variant="status"
        />
        <PrinterButton onPress={printData} label="Print" variant="print" />
        <PrinterButton
          onPress={clearResponses}
          label="Clear Responses"
          variant="clear"
        />
        <ResponseDisplay label="Status Response:" response={statusResponse} />
        <ResponseDisplay label="Print Response:" response={printResponse} />
      </View>
    </ScrollView>
  );
}
